import  { VitalModel } from "store/types/models";
import { createSlice,PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  bpVital:{
    name: 'Blood Pressure',
    unit: '',
    icon: "BP"
  } as VitalModel,

  weVital:{
    name: 'Weight',
    unit: 'kg',
    icon: "WT"
  } as VitalModel,

  glVital:{ 
    name: 'Glucose level',
    unit: 'm/dl',
    icon: "GL"
  } as VitalModel,

  gaVital:{
    name: 'Gestational Age',
    value: "",
    unit: 'days',
    icon: "GD"
  },

  cdVital:{
    name: 'Cycle Date',
    value: "",
    unit: '',
    icon: "CAL"
  },

  eddVital:{
    name: 'Est. Due Date',
    value: "",
    unit: '',
    icon: "CAL"
  },

  vitals:[] as VitalModel[],
};

export const vitalSlice = createSlice({
  name: "VitalSlice",
  initialState: initialState,
  reducers: {
    setBPVital: (state, action:PayloadAction<VitalModel>) => {
      state.bpVital = {...state.bpVital, ...action.payload}
    },
    setWEVital: (state, action:PayloadAction<VitalModel>) => {
      state.weVital = {...state.weVital, ...action.payload}
    },
    setGLVital: (state, action:PayloadAction<VitalModel>) => {
      state.glVital = {...state.glVital, ...action.payload}
    },
    setGAVital: (state, action) => {
      state.gaVital = {...state.gaVital, value:action.payload}
    },
    setCDVital: (state, action) => {
      state.cdVital = {...state.cdVital,value:action.payload}
    },
    setEDDVital: (state, action) => {
      state.eddVital = {...state.eddVital, value:action.payload}
    },
    setVitals: (state, action:PayloadAction<VitalModel[]>) => {
      state.vitals = action.payload
    },

  },
});

export const { setBPVital, setWEVital, setGLVital, setGAVital, setCDVital, setEDDVital,setVitals } =
  vitalSlice.actions;

export default vitalSlice.reducer;